module.exports = __webpack_public_path__ + "static/media/HoloLens-Multiuser-L.678ee2f9.jpg";